import { FC, useMemo } from "react";
import { Button } from "@radix-ui/themes";
import { ColumnDef } from "@tanstack/react-table";
import { LegacyFirestoreUserSummarySchema } from "@/domains/openapi/types";
import { Table } from "@/components/table/table";
import { UuidFieldRow } from "@/components/table/uuid-field-row";
import { TextFieldRow } from "@/components/table/text-field-row";
import { orderBy } from "lodash-es";

interface LegacyFirestoreUsersTableProps {
  data: LegacyFirestoreUserSummarySchema[];
  onViewLegacyFirestoreUser: (id: string) => void;
  pageSize: number;
}

export const LegacyFirestoreUsersTable: FC<LegacyFirestoreUsersTableProps> = ({
  data,
  onViewLegacyFirestoreUser,
  pageSize,
}) => {
  const columns = useMemo<ColumnDef<LegacyFirestoreUserSummarySchema>[]>(
    () => [
      {
        header: "Legacy Firestore User ID",
        cell: ({ row }) => <UuidFieldRow id={row.original.firestore_user_id} truncate={false} />,
      },
      {
        header: "Name",
        cell: ({ row }) => <TextFieldRow value={row.original.profile_display_name} />,
      },
      {
        header: "Email",
        cell: ({ row }) => <TextFieldRow value={row.original.profile_email_address} />,
      },
      {
        header: "View",
        cell: ({ row }) => (
          <Button
            variant="outline"
            size="1"
            onClick={() => onViewLegacyFirestoreUser(row.original.firestore_user_id)}
          >
            View
          </Button>
        ),
      },
    ],
    [onViewLegacyFirestoreUser]
  );

  const sortedData = useMemo(() => {
    return orderBy(data, ["profile_email_address", "firestore_user_id"], ["asc", "asc"]);
  }, [data]);

  return <Table data={sortedData} columns={columns} pageSize={pageSize} />;
};
